import React, {useState, useEffect} from 'react';

const SingleLicense = ({ licenseId }) => {
    const [licenseInfo, setLicenseInfo] = useState(null);
    
    useEffect(() => {
        const fetchLicenseDetails = async () => {
            try {
                const response = await fetch(EASYCOMMERCE.rest_base + '/licenses/' + licenseId, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': EASYCOMMERCE.nonce,
                    },
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setLicenseInfo(data.data);
            } catch (error) {
                console.error('Error fetching license details:', error);
            }
        };

        fetchLicenseDetails();
    }, []);

    const licenseData = [
        {
            label: 'License Key',
            value: licenseInfo ? licenseInfo.key : 'Loading...',
        },
        {
            label: 'Order ID',
            value: (
                <a className="text-ec-body hover:text-ec-primary duration-300" style={{ textDecoration: 'none' }} href={`#orders/${licenseInfo ? licenseInfo.order_id : 'Loading...'}`}>{licenseInfo ? '#' + licenseInfo.order_id : 'Loading...'}</a>
            ),
        },
        {
            label: 'Product Name',
            value: licenseInfo ? licenseInfo.product_name : 'Loading...',
        },
        {
            label: 'Customer Name',
            value: licenseInfo ? licenseInfo.customer_name : 'Loading...',
        },
        {
            label: 'Activation Limit',
            value: licenseInfo ? licenseInfo.activation_limit : 'Loading...',
        },
        {
            label: 'Expiry',
            value: licenseInfo ? licenseInfo.expiry : 'Loading...',
        },
        {
            label: 'Status',
            value: licenseInfo ? licenseInfo.status : 'Loading...',
        }
    ]

	return (
		<>
			<h3 className="easycommerce-dashboard-section-title !text-lg sm:!text-2xl">
				License #{licenseId}
			</h3>
			<div className="grid grid-cols-2 gap-6">
                {/* License info */}
				<div class="flex flex-col">
					<div class="w-full p-4 pb-3 border border-b-0 border-ec-border rounded-tl-lg rounded-tr-lg">
						<h3 class="font-inter easycommerce-dashboard-order-section-title m-0">
							License info
						</h3>
					</div>
					<div class="w-full h-full flex flex-col gap-1 p-4 py-6 border border-ec-border rounded-bl-lg rounded-br-lg">
                        {licenseData.map((item, index) => (
                            <div key={index} class="w-full h-[42px] flex justify-between items-center border-b border-dashed border-b-ec-border">
                                <p class="font-inter font-normal text-sm leading-4 text-ec-placeholder m-0">
                                    {item.label}
                                </p>
                                <p class="font-inter font-normal text-sm leading-4 text-ec-body m-0">
                                    {item.label !== 'Status' ? item.value :
                                        (() => {
                                            switch (licenseInfo?.status) {
                                                case 'active':
                                                    return <span style={{ color: '#00A900' }}>Active</span>;
                                                case 'expired':
                                                    return <span className="text-ec-body">Expired</span>;
                                                case 'blocked':
                                                    return <span className="text-[#FF3A52]">Blocked</span>;
                                                case 'inactive':
                                                    return <span className="text-ec-body">Inactive</span>;
                                                default:
                                                    return <span className="text-ec-body">Inactive</span>;
                                            }
                                        })()
                                    }
                                </p>
                            </div>
                        ))}
					</div>
				</div>

                {/* Active site table */}
                <div class="flex flex-col">
					<div class="w-full p-4 pb-3 border border-b-0 border-ec-border rounded-tl-lg rounded-tr-lg">
						<h3 class="font-inter easycommerce-dashboard-order-section-title m-0">
							{licenseInfo ? `Activations ${licenseInfo?.activations?.length + '/' + licenseInfo.activation_limit}` : `Loading...`}
						</h3>
					</div>
					<div class="w-full h-full flex flex-col gap-1 p-4 py-6 border border-ec-border rounded-bl-lg rounded-br-lg">
                        <div className="w-full h-[42px] flex justify-between items-center border-b border-dashed border-b-ec-border">
                            <p className="font-inter font-normal text-sm leading-4 text-ec-body m-0">
                                Active Sites
                            </p>
                            <p className="font-inter font-normal text-sm leading-4 text-ec-body m-0">
                                Activation Time
                            </p>
                        </div>
                        {licenseInfo?.activations.length > 0 ? licenseInfo?.activations?.map((item, index) => (
                            <div key={index} class="w-full h-[42px] flex justify-between items-center border-b border-dashed border-b-ec-border">
                                <p class="font-inter font-normal text-sm leading-4 text-ec-body m-0">
                                    {item.site}
                                </p>
                                <p class="font-inter font-normal text-sm leading-4 text-ec-body m-0">
                                    {item.activated_at}
                                </p>
                            </div>
                        )) : (
                            <p class="font-inter font-normal text-sm leading-4 text-ec-body m-0 py-3">
                                No active sites found.
                            </p>
                        )}
					</div>
				</div>
			</div>
		</>
	);
};

export default SingleLicense;
